import axios from 'axios'

const root = '/api/i18n'

class I18nHttpService {
  async fetch (lang) {
    const response = await axios.get(`${root}/${lang}.json`)
    return response.data
  }
}

export default new I18nHttpService()
